import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { update } from '../../../app/setters/update.js'

export const useZmienHaslo = (setErrors, onSuccessCallback) =>
    useMutation({
        mutationFn: (data) => update('/uzytkownik/zmiana-hasla', data),
        onSuccess: (data) => {
            if (data?.status === 'success') {
                setErrors({})
                toast.success(data?.message || 'Haslo zostalo zmienione.')
                onSuccessCallback?.()
                return
            }

            if (data?.errors) {
                setErrors(data.errors)
            }

            toast.error(data?.message || 'Nie udalo sie zmienic hasla.')
        },
        onError: (error) => {
            if (error?.response?.data?.errors) {
                setErrors(error.response.data.errors)
            }

            toast.error('Blad podczas zmiany hasla.')
        },
    })
